import { on } from "./dom";

/** Light/dark toggle. The server sets `<html data-theme>` from a cookie (no flash);
 *  this just flips it and persists the choice. */
export function initTheme(): void {
  for (const btn of document.querySelectorAll('[data-action="theme"]')) {
    on(btn, "click", () => {
      const next = document.documentElement.dataset.theme === "light" ? "dark" : "light";
      document.documentElement.dataset.theme = next;
      document.cookie = `theme=${next}; path=/; max-age=31536000; samesite=lax`;
    });
  }
}
